import { useEffect, useRef } from "react";
import { useDetectWhiteOverlay } from "@hooks/useDetectWhiteOverlay";
import { cn } from "@util/helpers";

import PulseEntryButton from "./PulseEntryButton";

export default function PulseEntry(): React.ReactElement {
  const containerRef = useRef<HTMLDivElement>(null);
  const { isOverlayDisplay } = useDetectWhiteOverlay();

  useEffect(() => {
    if (typeof window === "undefined") return;

    const getContainerWidth =
      window.document.getElementsByClassName("container")?.[0].clientWidth;

    if (!getContainerWidth || !containerRef.current) return;

    containerRef.current.style.right = `calc((100svw - ${getContainerWidth}px)/ 2)`;
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (typeof window === "undefined") return;

      const getContainerWidth =
        window.document.getElementsByClassName("container")?.[0].clientWidth;

      if (!getContainerWidth || !containerRef.current) return;

      containerRef.current.style.right = `calc((100svw - ${getContainerWidth}px)/ 2)`;
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div
      className={cn("fixed bottom-40 right-4 z-[99999] px-3 lg:px-0")}
      data-testid="pulse-entry-component"
      ref={containerRef}
    >
      {!isOverlayDisplay ? <PulseEntryButton /> : null}
    </div>
  );
}
